var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group has-label"},[_c('label',{attrs:{"for":_vm.prop}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"value status-line",domProps:{"innerHTML":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }